import img from "../../images/missions/Protéger_l'environnement_Rennemoulin_option 2I.jpg";

const MissionIssue = () => {
  return (
    <div className="container px-4 mx-auto mt-10 mb-10 sm:px-6 lg:px-8">
      <h1 className="text-xl font-bold text-center text-black">
        L’action d’Hydreaulys s’inscrit dans le cadre des exigences fixées par
        la directive européenne sur les eaux résiduaires urbaines (DERU) et la
        directive-cadre sur l’eau (DCE).
      </h1>
      <div className="py-6 mt-10 bg-white sm:py-8">
        <div className="flex flex-col max-w-6xl gap-6 px-4 mx-auto md:flex-row md:items-center">
          {/* Left Column: Cards - Centered */}
          <div className="flex justify-center md:w-1/2">
            <div className="grid max-w-lg grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="p-4 rounded-lg sm:p-6 text-start bg-teal-50">
                <p className="text-base font-bold text-primary">Biodiversité</p>
                <p className="text-base font-medium text-primary">
                  Protection des espèces aquatiques locales
                </p>
              </div>
              <div className="p-4 rounded-lg sm:p-6 text-start bg-teal-50">
                <p className="text-base font-bold text-primary">
                  Qualité de l'eau
                </p>
                <p className="text-base font-medium text-primary">
                  Surveillance continue des paramètres
                </p>
              </div>
              <div className="p-4 rounded-lg sm:p-6 text-start bg-teal-50">
                <p className="text-base font-bold text-primary whitespace-nowrap">
                  Réduction des pollutions
                </p>
                <p className="text-base font-medium text-primary">
                  Traitement avancé des microplastiques
                </p>
              </div>
              <div className="p-4 rounded-lg sm:p-6 text-start bg-teal-50">
                <p className="text-base font-bold text-primary">
                  Sensibilisation
                </p>
                <p className="text-base font-medium text-primary">
                  Programmes éducatifs pour le public
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Image and Caption */}
          <div className="flex flex-col w-full md:w-1/2">
            <div className="w-full h-48 overflow-hidden rounded-lg sm:h-64 md:h-80">
              <img
                src={img}
                alt="Ru de Gally à Rennemoulin"
                className="w-full h-full "
              />
            </div>
            <p className="mt-4 text-base italic text-gray-600 text-start">
              L'action d'Hydreaulys a pour but de préserver le milieu naturel.
              Les eaux traitées sont rejetées dans le ru de Gally, ici à
              Rennemoulin (Yvelines)
            </p>
          </div>
        </div>
      </div>

      <div className="text-base text-black text-start">
        La vérification des raccordements,{" "}
        <a
          href="https://www.hydreaulys.fr/ouvrages-installations?réseau-de-Collecteurs"
          className="underline"
          target="_blank"
          rel="noreferrer"
        >
          l’entretien des réseaux
        </a>
        , le traitement des effluents et la valorisation des{" "}
        <a
          href="https://www.hydreaulys.fr/innovations"
          className="underline"
          target="_blank"
          rel="noreferrer"
        >
          boues d’épuration
        </a>
        , toutes ces missions assurées par le syndicat contribuent à la bonne
        qualité environnementale du ru de Gally, où sont rejetées les eaux
        usées, une fois traitées. <br /> Prenant sa source dans le parc du
        château de Versailles, le{" "}
        <a
          href="https://www.hydreaulys.fr/gemapi?ru-de-gally"
          className="underline"
          target="_blank"
          rel="noreferrer"
        >
          ru de Gally
        </a>
        , petit cours d’eau de 22 kilomètres de long, se jette dans la Mauldre,
        elle-même affluent de la Seine. <br />
        Connu à l’époque de Louis XIV pour regorger de truites et d’écrevisses,
        il a souffert de l’activité humaine. Considérée comme préoccupante en
        1960, sa santé s’est depuis nettement améliorée grâce à l’optimisation
        des performances de l{" "}
        <a
          href="https://www.hydreaulys.fr/ouvrages-installations?carré-de-réunion"
          className="underline"
          target="_blank"
          rel="noreferrer"
        >
          usine Carré de Réunion
        </a>
        .
      </div>
    </div>
  );
};

export default MissionIssue;
